import React from 'react';
import { Helmet } from 'react-helmet-async';

function Seo({ title, description, image }) {
  const fullTitle = title ? `${title} — Libros para Viajeros` : 'Libros para Viajeros — Leer. Viajar. Descubrir.';
  const canonical = typeof window !== 'undefined' ? window.location.href.split('?')[0] : undefined;

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description ? <meta name="description" content={description} /> : null}
      {canonical ? <link rel="canonical" href={canonical} /> : null}
      <meta property="og:title" content={fullTitle} />
      {description ? <meta property="og:description" content={description} /> : null}
      {canonical ? <meta property="og:url" content={canonical} /> : null}
      {image ? <meta property="og:image" content={image} /> : null}
      <meta name="twitter:card" content="summary_large_image" />
    </Helmet>
  );
}

export default Seo;
